export const sxStyles = {
  wrap: {
    '.MuiPaper-root': {
      maxWidth: '590px',
      width: '100%',
      borderRadius: '12px',
    },
  },
  title: {
    margin: '0 0 1.5rem 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
};
